export default {"src":"/pro/_next/static/media/orderbook-bids-icon.79fd453a.svg","height":21,"width":24,"blurWidth":0,"blurHeight":0};